<template>
	<span v-if='show'>{{ timerLeft }}</span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name:'EventVotingCountdown',
	props: {
		event_voting_id: Number
	},
	data: () => ({
		clock: null,
		timerLeft: '00:00',	
	}),
	watch : {
		event_listener: function(listen) {
			if(listen && listen.key=='EventVotingTimerUpdate' && listen.payload.event_voting_id==this.event_voting_id) 
				this.votingTimerCommand(listen.payload.timer_ended_at);
			
		},
	},
	computed: {
		...mapGetters([
			'event_listener'
		]),
		vote() {
			return this.$store.state.event.event_voting.find(ev => ev.id == this.event_voting_id)
		},
		show() {
			return this.vote && this.vote.status ==1 && this.vote.timer &&this.vote.timer_started_at
		}
	},
	created() {
		if(this.show)
			this.votingTimerCommand(this.vote.timer_ended_at);
	},
	methods: {
		
		calculateVotingTimer(end_time_obj, now) {
			const diffTime = Math.abs(end_time_obj.getTime() - now.getTime()) / 1000;
			let minutes = Math.floor(diffTime / 60);
			let seconds = Math.floor(diffTime % 60);
			minutes = minutes > 9 ? minutes : '0' + minutes.toString();
			seconds = seconds > 9 ? seconds : '0' + seconds.toString();
			this.timerLeft = `${minutes}:${seconds}`;
		},
		async votingTimerCommand(timer_ended_at) {
			
			if(this.clock) {
				clearInterval(this.clock);
				// this.clock = null;
				this.timerLeft = '00:00';
			}

			const end_time_obj = new Date(timer_ended_at);
			const now = await this.$store.dispatch('getServerTime'); // from app.js

			if (end_time_obj.getTime() > now.getTime()) {
				this.calculateVotingTimer(end_time_obj, now)
				

				this.clock = setInterval(async () => {
					const newTime = await this.$store.dispatch('getServerTime');

					if (newTime.getTime() >= end_time_obj.getTime()) {
						this.votingTimerCommand();
					} else {
						this.calculateVotingTimer(end_time_obj, newTime)
					}
				}, 1000);
			}
		}
	}
}
</script>

<style>

</style>